import { render, staticRenderFns } from "./OrticVueEditor.vue?vue&type=template&id=5b725bfb"
import script from "./OrticVueEditor.vue?vue&type=script&lang=js"
export * from "./OrticVueEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports